<template>
    <div class="panel">
        <div class="panel-body">
            <div class="row">
                <div class="col-sm-4 rentals-form-inner">
                    <!-- ///////////////// -->
                    <!-- FACTURE -->
                    <!-- ///////////////// -->
                    <div class="panel-content-inner">
                        <h4 class="inner-title">
                            Facture
                        </h4>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group form-material">
                                    <label class="control-label" for="rentals-name">
                                        Logo
                                    </label>
                                    <div class="images-rentals">
                                        <div class="row">
                                            <div class="col">
                                                <div class="photo">
                                                    <v-loading
                                                        :isLoading="rentalImageIsDeleting"
                                                        :height="50"
                                                        :width="50"
                                                        :viewbox="'0 0 50 50'"
                                                        :cx="25"
                                                        :cy="25"
                                                        :r="22"
                                                    >
                                                    </v-loading>
                                                    <div
                                                    v-if="!rentalImageIsDeleting"
                                                    >
                                                        <img
                                                            class="img-responsive"
                                                            :src="invoice.logo"
                                                        />
                                                        <div class="visuel-wrapper">
                                                            <div class="rental-invoice-masque">
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-block btn-warning waves-effect waves-classic waves-effect waves-classic"
                                                                    @click="deleteLogo"
                                                                >
                                                                    {{ $t("button.delete") }}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="example">
                                            <input
                                                type="file"
                                                id="input-file-now"
                                                data-plugin="dropify"
                                                data-default-file=""
                                                data-allowed-file-extensions="jpg png jpeg"
                                                @change="addLogo"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group form-material">
                                    <label class="control-label" for="rentals-name">
                                        IBAN
                                    </label>
                                    <textarea class="form-control" rows="3" required v-model="invoice.bank_details"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group form-material">
                                    <label class="control-label" for="rentals-name">
                                        Pieds de page
                                    </label>
                                    <textarea class="form-control" rows="3" required v-model="invoice.footer"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group form-material">
                                    <label class="control-label" for="rentals-name">
                                        TVA
                                    </label>
                                    <!-- // create number input -->
                                    <div class="input-group">
                                        <input
                                        type="number"
                                        class="form-control"
                                        placeholder="0"
                                        v-model="invoice.vat"
                                        />
                                        <span class="input-group-addon">
                                            %
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4 rentals-form-inner">
                    <!-- ///////////////// -->
                    <!-- INFO USER -->
                    <!-- ///////////////// -->
                    <div class="panel-content-inner">
                        <h4 class="inner-title">
                            Informations
                        </h4>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group form-material">
                                    <label class="control-label" for="rentals-name">
                                        First name
                                    </label>
                                    <input type="text" class="form-control" v-model="info.first_name">
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group form-material">
                                    <label class="control-label" for="rentals-name">
                                        Last name
                                    </label>
                                    <input type="text" class="form-control" v-model="info.last_name">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group form-material">
                                    <label class="control-label" for="rentals-name">
                                        Address
                                    </label>
                                    <input type="text" class="form-control" v-model="info.address">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group form-material">
                                    <label class="control-label" for="rentals-name">
                                        City
                                    </label>
                                    <input type="text" class="form-control" v-model="info.city">
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group form-material">
                                    <label class="control-label" for="rentals-name">
                                        Zipcode
                                    </label>
                                    <input type="text" class="form-control" v-model="info.zipcode">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group form-material">
                                    <label class="control-label" for="rentals-name">
                                        Téléphone
                                    </label>
                                    <input type="text" class="form-control" v-model="info.phone">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group form-material">
                                    <label class="control-label" for="rentals-name">
                                        Email
                                    </label>
                                    <input type="text" class="form-control" v-model="info.email">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import superconciergerie from "../../../services/superconciergerie";
import moment from "moment";

export default {
  data() {
    return {
      resourceLoaded: false,
      rentalImageIsDeleting: false,
      invoice: {
        logo: "",
        bank_details: "",
        footer: "",
        vat: 0,
      },
      info: {
        first_name: "",
        last_name: "",
        address: "",
        city: "",
        zipcode: "",
        phone: "",
        email: "",
      },
    };
  },
  components: {
    VLoading: require("components/loading/loading.vue"),
    Redactor: require('components/redactor/redactor.vue'),
  },
  methods: {
    moment,
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    async loadResource() {
      if (this.activeTab === "settings" && !this.resourceLoaded) {
        await superconciergerie.getSettings(this);
        this.resourceLoaded = true;
      }
    },
    deleteLogo() {
        this.invoice.logo = null;
    },
    async addLogo(e) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length)
            return;
        this.invoice.logo = files[0];
    },
    async updateSettings() {
        // const formData = new FormData();
        // formData.append('image', this.invoice.logo);
        await superconciergerie.updateSettings(this, this.invoice, this.info, this.invoice.logo);
    }
  },
  props: ["activeTab"],
  async mounted() {
    await this.loadResource();
  },
  watch: {
    activeTab: async function (val) {
      await this.loadResource();
    },
  },
};
</script>



// WEBPACK FOOTER //
// SettingsTab.vue?2174e308